import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

import ButtonInput from './ButtonInput';
import PersonasViewer from './sidebar/PersonasViewer';
import copyToClipboard from '../../utilities/copy';
import {event} from '../../utilities/withAnalytics';

import './Sidebar.scss';
import YoureNotADesigner from '../../components/YoureNotADesigner';

class Sidebar extends Component {

  state = {
    email: '',
  }

  viewLink = (id) => {
    const theId = id || '';
    return window.location.origin + '/' + theId;
  }

  editLink = (id, key) => {
    if (id && key) {
      return window.location.origin + '/' + id + '/' + key;
    } else {
      return 'Create persona first!';
    }
  }

  printPersona = (e) => {
    event('Print','Click', this.props.id);
    window.print();
  }

  copy = (e) => {
    e.preventDefault();
    const targetInput = e.target.getElementsByTagName('input')[0];
    const theValue = targetInput.value;
    const formKey = targetInput.name;
    copyToClipboard(theValue);
    event('Copy','Click', formKey);
    // TODO: Only allow calling of one copy alert at a time.
    this.props.alertStore.addAlert({
      type: 'success',
      message: 'copied',
      timer: 1500
    });
  }

  onEmailChange = (e) => {
    this.setState({email: e.target.value});
  }

  sendEmail = (e) => {
    e.preventDefault();
    event('email', 'click', this.props.personaStore.id);
    this.props.sidebarStore.addEmail(this.state.email);
  }

  toggleIndicators = () => {
    this.props.sidebarStore.toggleIndicators();
  }

  render() {
    const {
      id,
      key,
    } = this.props.personaStore;
    const {email} = this.state;
    const {
      personaList,
      showIndicators,
    } = this.props.sidebarStore;
    return (
      <div className="sidebar">
        <YoureNotADesigner />
        <div className="sidebar-section">
          <h3 className="sidebar-section-heading">Share{key && ' & Edit'}</h3>
          <p>Secure links to view{key && ' & edit'} this persona. No signup required!</p>
          <ButtonInput
            action={this.copy}
            value={this.viewLink(id)}
            disabled={true}
            formKey="view_link"
            icon="files-o"
            type="url"
          />
          <small className="sidebar-small">
            this is a non-editable link to view this persona | share this link
          </small>
          {key && (
            <div>
              <ButtonInput
                action={this.copy}
                value={this.editLink(id, key)}
                disabled={true}
                disabledButton={key === undefined}
                formKey="edit_link"
                icon="files-o"
                type="url"
              />
              <small className="sidebar-small">
                this is the edit link to this persona, without it you can't edit your persona
              </small>
            </div>
          )}
          <ButtonInput
            action={this.sendEmail}
            formKey="email"
            icon="paper-plane"
            onChange={this.onEmailChange}
            placeholder="you@email.com"
            type="email"
            value={email}
          />
          <small className="sidebar-small">use your email to receive a copy of this persona's view
          and edit links</small>
        </div>
        <div className="sidebar-section">
          <h3 className="sidebar-section-heading">Download & Print</h3>
          <small className="sidebar-small">Note: Blue outlines indicate what is editable and are only visible in
          editing mode. They are not included in the VIEW link, nor in the downloaded or printed versions.</small>
          <div className="sidebar-button-container">
            {false && <button
              type="button"
              className="sidebar-button btn btn-primary">
              <i className="fa fa-download"/> Download
            </button>}
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.printPersona}>
              <i className="fa fa-print"/> Print
            </button>
          </div>
        </div>
        <div className="sidebar-section">
          <h3 className="sidebar-section-heading">Options</h3>
            <input
              name="show_indicators"
              id="show_indicators"
              type="checkbox"
              checked={showIndicators}
              onChange={this.toggleIndicators}
            />
            <label htmlFor="show_indicators" className="sidebar-checkbox-label">
              Show Editable Indicators
            </label>
        </div>
        <div className="sidebar-section">
          <h3 className="sidebar-section-heading">My Personas ({personaList.length})</h3>
          <small className="sidebar-small">Here’s all the personas we have record of you visiting or editing. If
          you don’t see your personas here it might be because you visited from a different browser or computer,
          or you cleared your browsing data.</small>
          <div className="sidebar-personasviewer-container">
            <PersonasViewer personaList={personaList} activeId={id} />
          </div>
        </div>
      </div>
    );
  }
}

export default inject(
  'alertStore',
  'personaStore',
  'sidebarStore',
)(observer(Sidebar));



// WEBPACK FOOTER //
// ./client/pages/persona/Sidebar.jsx